import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { GoogleMap as GoogleMapComponent, Marker } from '@react-google-maps/api';
import { useState } from 'react';
import spotlightMarker from '../../../../../assets/images/hotelDetailsOverlay/map-marker.svg';
export const GoogleMap = ({
  lat,
  lng,
  hotelName,
  mapOptions
}) => {
  const center = {
    lat,
    lng
  };
  const [isTilesLoaded, setIsTilesLoaded] = useState(false);
  const mapContainerStyle = {
    height: '100%',
    opacity: isTilesLoaded ? 1 : 0
  };
  const label = {
    text: hotelName,
    className: 'hotel-details-overlay-map-marker-label'
  };
  return _jsx(GoogleMapComponent, {
    center: center,
    zoom: 15,
    mapContainerStyle: mapContainerStyle,
    options: mapOptions,
    onTilesLoaded: () => setIsTilesLoaded(true),
    children: _jsx(Marker, {
      position: center,
      label: label,
      icon: {
        url: spotlightMarker,
        labelOrigin: new google.maps.Point(95, 22)
      }
    })
  });
};